/* @flow */
import {
  buttonModalActionMaker,
  subscribtionCardActionMaker
} from '@website/components/ActionMakers'
import {
  addBlock,
  changeTitle,
  changeParagraph,
  changeTitleAlignment,
  changeParagraphAlignment
} from '@website/components/CommonActions'
import DeleteIcon from '@editor/common/assets/svgr-icons/Delete_icon_2.svg'
import { translate } from '@editor/common/utils/translations'

export default dispatcher => {
  const changeCardData = (
    planIdx: number,
    data: string,
    keyInStore: string
  ) => {
    dispatcher({
      type: 'CHANGE_CARD_DATA',
      value: { keyInStore, planIdx, data }
    })
  }
  const changeCardTitle = (title: string, planIndex: number) => {
    dispatcher(changeCardData(planIndex, title, 'cardTitle'))
  }

  const changeLabelTitle = (price: string, planIdx: number) => {
    dispatcher(changeCardData(planIdx, price, 'labelTitle'))
  }

  const changeLabelParagraph = (date: string, planIdx: number) => {
    dispatcher(changeCardData(planIdx, date, 'labelParagraph'))
  }

  const addOption = (planIndex: number) => {
    dispatcher({
      type: 'ADD_OPTION',
      value: planIndex
    })
  }

  const removeOption = (planIdx: number, optionIdx: number) => {
    dispatcher({
      type: 'REMOVE_OPTION',
      value: { planIdx, optionIdx }
    })
  }

  const optionActions = (planIdx: number, optionIdx: number) => [
    {
      IconComp: DeleteIcon,
      tooltipText: translate('delete_label'),
      handler: () => dispatcher(removeOption(planIdx, optionIdx))
    }
  ]
  const changeOptnValue = (planIndex: number, idx: number, text: string) => {
    dispatcher({
      type: 'CHANGE_OPTION_VALUE',
      value: {
        idx,
        text,
        planIndex
      }
    })
  }

  const _addBlock = () => {
    dispatcher(addBlock())
  }

  const _changeTitle = (title: string) => {
    dispatcher(changeTitle(title))
  }

  const _changeParagraph = (paragraph: string) => {
    dispatcher(changeParagraph(paragraph))
  }

  const _changeTitleAlignment = (alignment: string) => {
    dispatcher(changeTitleAlignment(alignment))
  }

  const _changeParagraphAlignment = (alignment: string) => {
    dispatcher(changeParagraphAlignment(alignment))
  }

  const changeCardTitleAlignment = (alignment: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_CARD_TITLE_ALIGNMENT',
      value: { alignment, idx }
    })
  }


  return {
    addBlock: _addBlock,
    addOption,
    changeTitle: _changeTitle,
    optionActions,
    changeLabelParagraph,
    changeCardTitle,
    changeLabelTitle,
    changeParagraph: _changeParagraph,
    changeOptnValue,
    changeTitleAlignment: _changeTitleAlignment,
    changeParagraphAlignment: _changeParagraphAlignment,
    changeCardTitleAlignment,
    btnActions: buttonModalActionMaker(dispatcher),
    cardAction: subscribtionCardActionMaker(dispatcher)
  }
}
